<template>
  <div>
    <Modal :visible="visible" @cancel="handleCancel">
      <ApplyCoupon
        :visible="visible"
        :planData="planDetail"
        :stayDay="stayDay"
        :stayNights="stayNights"
        :stayRooms="stayRooms"
        :vacancyCalendar="vacancyCalendar"
        :publicStayMode="true"
        :roomDetails="roomDetails"
        source="order_confirmation"
        @change="onChangeCouponPlan"
        @ok="handleOk"
        @getTotalCoupon="getTotalCoupon"
        @cancel="handleCancel"
      />
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash'
import ApplyCoupon from '../ApplyCoupon'
import { generateRoomDetailsForApplyCoupon } from '../../../utils/dataConverters'

export default {
  name: 'UseCouponPopup',
  components: {
    ApplyCoupon
  },
  props: ['visible'],
  data() {
    return {
      dateFormat: 'YYYY/MM/DD',
      planDetail: null,
      stayDay: null,
      stayNights: null,
      stayRooms: null,
      vacancyCalendar: null,
      couponObj: null,
      roomDetails: null,
    }
  },
  mounted() {

    // ApplyCouponコンポーネントを利用するために、
    // UIから入力された情報を、ApplyCouponコンポーネントで利用できる形式に変換する
    this.dev('mounted UseCouponPopup')
    this.dump('stateStayDay', this.stateStayDay)
    this.dump('statePlanDetail', this.statePlanDetail)
    this.dump('stateCustomerPlan', this.stateCustomerPlan)
    this.dump('publicStayInfo', this.publicStayInfo)
    if (this.statePlanDetail) {
      this.planDetail = this.statePlanDetail
    }
    if (this.stateCustomerPlan) {
      this.stayDay = this.stateCustomerPlan.stayDays
      this.stayNights = this.stateCustomerPlan.stayNights // orderPublicStay.stayDateRoom.date
      this.vacancyCalendar = undefined
    }
    // 部屋詳細情報(各種メンバ変数煮格納後に最後実施)
    this.roomDetails = generateRoomDetailsForApplyCoupon(this.publicStayInfo)
  },
  computed: {
    // // stateStayDay() {
    // //   return this.$store.getters['order/get']?.orderPublicStay?.stayDateRoom?.date;
    // },
    statePlanDetail() {
      return _.cloneDeep(this.$store.getters.planDetail)
    },
    stateCustomerPlan() {
      // orderPublicStay.stayDateRoom.date
      return _.cloneDeep(this.$store.getters.customerPlan)
    },
    publicStayInfo() {
      return _.get(this.$store.getters, 'bs_app.public_stay', null)
    },

    // bsAppState() {
    //   return cloneDeep(this.$store.getters.bs_app)
    // },
    // userInfo() {
    //   return this.$store.getters['auth/get'].user
    // },
  },
  methods: {
    dev(msg){
      // alert(msg)
      // console.log(msg)
    },
    dump(...args){
      // console.log(...args)
    },

    onChangeCouponPlan() {
      this.dev('onChangeCouponPlan!! TODO: 要検討')
      // TODO: 要検討
      // this.updatedCouponData = JSON.parse(JSON.stringify($event))
    },
    getTotalCoupon($event) {
      this.couponObj = $event
    },
    handleOk($event) {
      this.$emit('ok', $event)
      this.$emit('getTotalCoupon', this.couponObj)
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="css">
.coupon-popup-footer {
  @apply flex justify-end gap-x-2;
}
</style>
